<div class="row">
  <div class="col-12 text-right"><span (click)="disableAssistant()" style="cursor:pointer;">x</span></div>
</div>
<div class="row">
  <div class="col-12">
    <ng-content></ng-content>
  </div>
</div>
